module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-information"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Account Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "m-h-200"
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "account-avatar"
  }, [_c('img', {
    staticClass: "avatar-img",
    attrs: {
      "src": _vm._f("resetURL")(_vm.currentAccount.avatar)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "avatar-desc"
  }, [_c('translate', [_vm._v("avatar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "upload-avatar",
    on: {
      "click": function($event) {
        _vm.fileClick()
      }
    }
  }, [_c('input', {
    staticClass: "upload-file",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png,image/gif,image/jpeg"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Change")])], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "team-info break-line"
  }, [_c('p', {
    staticClass: "info-name"
  }, [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("Team Name:")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentTeam.full_name))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("Team code:")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentTeam.domain))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "team-info"
  }, [_c('p', {
    staticClass: "info-name"
  }, [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("Display Nickname:")])], 1), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "limit-text"
  }, [_vm._v(_vm._s(_vm.currentAccount.name))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-edit edit-name",
    on: {
      "click": function($event) {
        _vm.showEditName()
      }
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "name-space"
  }, [_c('translate', [_vm._v("login account:")])], 1), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "limit-text"
  }, [_vm._v(_vm._s(_vm.currentAccount.account))])])])])])], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ecad13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/account-info.vue
// module id = 542
// module chunks = 4 5 6